<template>
        <div class="row justify-content-center">
        <p> Veuillez patienter nous vous redirigeons vers votre compte souscripteur: </p>
        <loading :active.sync="isLoading"
                 :can-cancel="canCancel"
                 :is-full-page="fullPage"
                 color="#2dcecc"
                 :opacity="opacity"
        >

        </loading>
        </div>
</template>
<script>
    import { required, email, minLength } from 'vuelidate/lib/validators';
    import AppConfig from '../constants/AppConfig';
    import loading from 'vue-loading-overlay';
    import { FadeTransition } from 'vue2-transitions';
    import router from '../router/router';
    export default {
        name: 'landing',

        components: {
            FadeTransition,
            loading,

        },
        data() {
            return {
                isLoading:true,
                opacity:0.5,
                canCancel:false,
                fullPage: true,
            };
        },
        methods: {
            invalidEmail: function() {
                if (this.$v.model.email.$dirty && this.$v.model.email.$error) {
                    return !this.$v.model.email.required ?
                        this.$i18n.t('message.requiredField') :
                        this.$i18n.t('message.emailNotValid');
                }

                return null;
            },

            submit: function() {
                 this.$store.dispatch('setLoading', {loading : true});
                var token = this.$route.query.token
                var status = this.$route.query.status
                // console.log(this.$route.query);
                if(status=="error")
                  router.push("/error");
                else{
                var res = token.split("medsur");
                var password = res[0];
                var email = res[1];
                let args = {
                    grant_type: 'password',
                    client_id: AppConfig.appClientId,
                    client_secret: AppConfig.appClientSecret,
                    username: email,
                    password: password
                };
                // console.log(args);
                if(password.length >=13){
                    this.$store.dispatch('loginRedirectHandler', { args });
                }else{
                 // this.$store.dispatch('loginRedirectHandler', { args });
                   this.$store.dispatch('loginHandler', { args });
                }
                }
            }
        },
        mounted() {
        this.submit();
        }
    }
</script>
<style scoped>
    @import '~vue-loading-overlay/dist/vue-loading.css';
</style>
